export const formatCNPJ = (cnpj) => {
    if (!cnpj) return '';
    let cnpjString = String(cnpj).replace(/\D/g, '');
    cnpjString = cnpjString.padStart(14, '0');
    return cnpjString.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

/** Código do cliente com dígito para exibição (12345-6); sem dígito, mostra só o código. */
export const formatCodigoCliente = (cdCliente, digitoCliente) => {
    if (cdCliente === null || cdCliente === undefined) return '';
    if (digitoCliente === null || digitoCliente === undefined) return String(cdCliente);
    return `${cdCliente}-${digitoCliente}`;
};